module.exports = __webpack_public_path__ + "static/media/YF107_5.d58eb146.jpg";